import { PaymentsQueryOptions } from "../../types";
import { EncountersQueryOptions } from "../types";

export const encountersKeys = {
    all: ["encounters"] as const,
    encounters: (opts: EncountersQueryOptions) => [...encountersKeys.all, opts] as const,
    upcomingEncounters: (opts: EncountersQueryOptions) => [...encountersKeys.all, "upcoming", opts] as const,
    refills: (opts: EncountersQueryOptions) => [...encountersKeys.all, "refills", opts] as const,
    todayEncounterRefills: (opts: EncountersQueryOptions) => [...encountersKeys.all, "refills", "today", opts] as const,
    appointments: (opts: EncountersQueryOptions) => [...encountersKeys.all, "appointments", opts] as const,
    encounterById: (id: string) => [...encountersKeys.all, "encounter", id] as const,
    appointmentsById: (opts: { id: string }) => [...encountersKeys.all, "appointments", opts] as const,
    refillsById: (opts: { id: string }) => [...encountersKeys.all, "refills", opts] as const,
  } as const;

export const paymentsKeys = {
  all: ["payments"] as const,
  payments: (opts: PaymentsQueryOptions) => [...paymentsKeys.all, opts] as const,
  paymentById: (id: string) => [...paymentsKeys.all, "payment", id] as const,
} as const;

